import { Routes } from '@angular/router';
import { LoginComponent } from './features/login/login.component';
import { DashboardLayoutComponent } from './features/dashboard/dashboard-layout/dashboard-layout.component';
import { RoleGuard } from './core/auth/guards/role/role.guard';
import { ResetMyPasswordComponent } from './features/users/pages/reset-my-password/reset-my-password.component';
import { ContactComponent } from './features/contact/contact.component';
import { PrivacyComponent } from './features/privacy/privacy.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'reset-password', component: ResetMyPasswordComponent },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'users',
        loadChildren: () =>
          import('./features/users/users.module').then(m => m.UsersModule),
        canActivate: [RoleGuard],
        data: { roles: ['SUPER_ADMIN', 'SALESPERSON', 'ADMIN'] }
      },
      {
        path: 'sales',
        loadChildren: () =>
          import('./features/sales/sales.module').then(m => m.SalesModule),
        canActivate: [RoleGuard],
        data: { roles: ['SUPER_ADMIN', 'SALESPERSON', 'ADMIN'] }
      },
      {
        path: 'requested-services',
        loadChildren: () =>
          import('./features/requested-services/requested-services.module').then(m => m.RequestedServicesModule),
        canActivate: [RoleGuard],
        data: { roles: ['SUPER_ADMIN', 'SALESPERSON', 'ADMIN'] }
      },
      {
        path: 'brands',
        loadChildren: () =>
          import('./features/brands/brands.module').then(m => m.BrandsModule),
        canActivate: [RoleGuard],
        data: { roles: ['SUPER_ADMIN'] }
      },
      {
        path: 'categories',
        loadChildren: () =>
          import('./features/categories/categories.module').then(m => m.CategoriesModule),
        canActivate: [RoleGuard],
        data: { roles: ['SUPER_ADMIN', 'ADMIN'] }
      },
      {
        path: 'orders',
        loadChildren: () =>
          import('./features/orders/orders.module').then(m => m.OrdersModule),
        canActivate: [RoleGuard],
        data: { roles: ['SUPER_ADMIN', 'ADMIN'] }
      },
      {
        path: 'products',
        loadChildren: () =>
          import('./features/products/products.module').then(m => m.ProductsModule),
        canActivate: [RoleGuard],
        data: { roles: ['SUPER_ADMIN', 'SALESPERSON', 'ADMIN'] }
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./features/reports/reports.module').then(m => m.ReportsModule),
        canActivate: [RoleGuard],
        data: { roles: ['SUPER_ADMIN', 'ADMIN'] }
      },
      {
        path: 'static-pages',
        loadChildren: () =>
          import('./features/static-pages/static-pages.module').then(m => m.StaticPagesModule),
        canActivate: [RoleGuard],
        data: { roles: ['SUPER_ADMIN', 'ADMIN'] }
      },
      {
        path: 'sliders',
        loadChildren: () =>
          import('./features/sliders/sliders.module').then(m => m.SlidersModule),
        canActivate: [RoleGuard],
        data: { roles: ['SUPER_ADMIN', 'ADMIN'] }
      }
    ]
  },
  { path: 'contact', component: ContactComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/login' }
];
